<template>
  <v-modal id="modal-commercial-drugs">
    <span slot="header">
      {{ i18nJS.equivalence_drugs_associated }}
    </span>
    <spinner :visible="inLoading"></spinner>

    <ul class="list">
      <li v-for="(drug, index) in drugs" :key="index" class="list-item">{{ drug.cod_minsan }} - {{ drug.nome_commerciale }}</li>
    </ul>
  </v-modal>
</template>

<script>
import apiConnector from '@/epersonam/apiConnector';
import spinner from '../spinner';
import vModal from '../vModal';
import { Route } from '../../route';

export default {
  name: 'commercialDrugsModal',
  props: [],
  components: {
    spinner,
    vModal,
  },
  data() {
    return {
      drugs: [],
      inLoading: false,
    };
  },
  mounted() {
    eventBus.$on('requestDrugsCommercialName', (drug) => {
      this.drugs = [];
      this.inLoading = true;
      apiConnector()
        .get(`${Route.DRUGS_CONFIG}/${drug.drug_id}/commercial_drugs_by_active_principle`)
        .then(({ data }) => {
          this.drugs = data;
          this.inLoading = false;
        })
        .catch(() => {
          this.inLoading = false;
          alert(i18nJS.errors.critical_error);
        });
    });
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.arg {
  font-style: italic;
  font-size: 13.6px;
  font-family: 'Source Sans Pro', sans-serif;
  text-decoration: none;
}
.list {
  color: #767676;
}
</style>
